<wl-modal (closeModal)="closeWithoutSubmit()" [modalTitle]="rendering().title">
  <ng-template wlModalBody>
    <wl-usage-questionnaire
      [rendering]="rendering()"
      (submitUsageQuestionnaire)="handleSubmit($event)"
    />
  </ng-template>
</wl-modal>
